import { render, staticRenderFns } from "./tr-2.vue?vue&type=template&id=50a219da&"
import script from "./tr-2.vue?vue&type=script&lang=ts&"
export * from "./tr-2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports